import React, { useState, useRef, useEffect } from 'react';

const ChatModal = ({ 
    applicationNumber, 
    chatMessages, 
    setChatMessages, 
    userId, 
    firstName, 
    lastName, 
    dealerId, 
    token, 
    config 
}) => {
    const [newChatMessage, setNewChatMessage] = useState('');
    const [chatbotResponse, setChatbotResponse] = useState('');
    const [postedNewChatMessage, setPostedNewChatMessage] = useState(false);
    const commentsContent = useRef(null);
    
    useEffect(() => {
        // Scroll to bottom when messages change
        if (commentsContent.current) {
            commentsContent.current.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
        }
    }, [chatMessages]);

    const handleTextAreaChange = (event) => {
        setNewChatMessage(event.target.value);
    };

    const upsertChatMessage = () => {
        // Don't send empty messages
        if (!newChatMessage.trim()) return;
        
        const currentDateTime = new Date();
        
        // Optimistically update UI
        setChatMessages(previousChatMessages => ([
            ...previousChatMessages, 
            {
                'date_time': currentDateTime.toString(),
                'user_id': userId ? userId : '',
                'first_name': firstName ? firstName : '',
                'last_name': lastName ? lastName : '',
                'message': newChatMessage
            }
        ]));
        
        // Clear input and show typing indicator
        setNewChatMessage('');
        setChatbotResponse(' is writing a response...');
        setPostedNewChatMessage(true);
        
        // Send message to server
        fetch('https://lybaq5bkd0.execute-api.us-east-2.amazonaws.com' + (localStorage.getItem('env') === '/prod' ? '/prod' : '') + '/dealerchatmessageupsert', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization':
                    config.dealer_chat_message_upsert_token + '/' +
                    (dealerId ? dealerId : '0') + '/' +
                    (userId ? userId : '0') + '/' +
                    (token ? token : '0'),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                'application_number': applicationNumber,
                'message': newChatMessage,
                'env': localStorage.getItem('env') ? localStorage.getItem('env') : ''
            })
        })
            .then((response) => response.json())
            .catch((err) => {
                console.log('Error:', err);
            });
        
        // Get chatbot response
        fetch('https://wg5b9u6hue.execute-api.us-east-2.amazonaws.com' + (localStorage.getItem('env') === '/prod' ? '/prod' : '') + '/aiglynn', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': config.ai_glynn_token,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                'prompt': newChatMessage,
                'user': firstName
            })
        })
            .then((response) => response.json())
            .then((response) => {
                setChatbotResponse(': ' + response.content);
            })
            .catch((err) => {
                console.log('Error:', err);
                setChatbotResponse(': Sorry, I could not process your request at this time.');
            });
    };

    // Handle enter key to send message
    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            upsertChatMessage();
        }
    };

    return (
        <div className="modal fade" id="comments_modal" tabIndex={-1} role="dialog" aria-labelledby="comments_modal" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="row">
                            <div className="row d-flex justify-content-center">
                                <div className="col-md-12 col-lg-10 col-xl-12">
                                    <div className="card overflow-auto" style={{ maxHeight: "500px", display: "flex", flexDirection: "column-reverse" }}>
                                        <div className="card-body">
                                            {chatMessages.map((chatMessage, index) => (
                                                <div key={index} style={{ maxHeight: "600px" }}>
                                                    <div className="d-flex flex-start align-items-center last-child" style={{ animation: "scrollToBottom 0.01s" }} >
                                                        <div>
                                                            <h6 className="fw-bold text-primary mb-1">{chatMessage.first_name} {chatMessage.last_name}</h6>
                                                            <p className="text-muted small mb-0">{chatMessage.date_time}</p>
                                                        </div>
                                                    </div>
                                                    <p className="mt-3 mb-4 pb-2">
                                                        {chatMessage.message}
                                                    </p>
                                                    <hr />
                                                </div>
                                            ))}
                                            <div ref={commentsContent} />
                                        </div>
                                    </div>
                                    <div className="card-footer py-3 border-0" style={{ backgroundColor: "#f8f9fa" }}>
                                        <div className="d-flex flex-start w-100">
                                            <div className="form-outline w-100">
                                                <textarea 
                                                    className="form-control" 
                                                    id="newChatMessage" 
                                                    name="newChatMessage" 
                                                    onChange={handleTextAreaChange} 
                                                    onKeyDown={handleKeyDown}
                                                    value={postedNewChatMessage ? '' : newChatMessage} 
                                                    rows={4} 
                                                    style={{ background: "#fff" }} 
                                                    autoComplete="off" 
                                                    autoFocus
                                                    placeholder="Type your message here..."
                                                ></textarea>
                                                <label className="form-label" htmlFor="newChatMessage">Message</label>
                                                {chatbotResponse ? <div><b>Glynn the Chatbot</b>{chatbotResponse}</div> : ''}
                                            </div>
                                        </div>
                                        <div className="float-end mt-4 pt-1">
                                            <button 
                                                type="button" 
                                                className="btn btn-primary" 
                                                onClick={upsertChatMessage}
                                                disabled={!newChatMessage.trim() || postedNewChatMessage}
                                            >
                                                Post Message
                                            </button> &nbsp;&nbsp;
                                            <button type="button" className="btn" data-bs-dismiss="modal" style={{ width: '120px', backgroundColor: "#808080", color: 'white' }}>Close</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(ChatModal);
